import {
  ROUTE_NNC_DASHBOARD_REPORT,
} from '@app/navigations/RoutePathConstant';
import {authLoader} from '@app/navigations/loader';
import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';

const NNCDashboardReport = lazy(() =>
  import('../../../screens/NNCDashboardReport')
    .then(module => ({default: module.NNCDashboardReport})));

const NNCDashboardReportNavigation = [{
  path: ROUTE_NNC_DASHBOARD_REPORT,
  loader: authLoader,
  element: (
    <Suspense fallback={<Spin />}>
      <NNCDashboardReport />
    </Suspense>
  ),
},
];

export default NNCDashboardReportNavigation;
